import { Inject, Injectable, InjectionToken } from '@angular/core';
import Pusher from 'pusher-js';
import { LOCATION } from '../../variables';
import { SessionService } from '../session/session.service';

export const PUSHER_CONSTRUCTOR = new InjectionToken<any>('PUSHER_CONSTRUCTOR', {
  providedIn: 'root',
  factory: () => Pusher,
});

@Injectable()
export class PusherService {
  pusher: any;

  constructor(
    @Inject(LOCATION) private location: Location,
    private sessionService: SessionService,
    @Inject(PUSHER_CONSTRUCTOR) private PusherConstructor: typeof Pusher,
  ) {
    const apiKey = 'afc5e03c98b528472cff';
    const parts = location.hostname.split('.').slice(1);
    const authEndpoint = ['//api', ...parts].join('.') + '/v1/session/notifications/auth';
    const params = {};
    if (this.sessionService.publicId) {
      params['public_id'] = this.sessionService.publicId;
    }
    this.pusher = new this.PusherConstructor(apiKey, { authEndpoint: authEndpoint, authTransport: 'jsonp', auth: { params: params } });
  }
}
